import * as React from "react";
import { Center } from "components/common";
import Spinner from "components/common/Spinner";
const LoadingWidget = () => /* @__PURE__ */ React.createElement(Center, null, /* @__PURE__ */ React.createElement(Spinner, { "data-testid": "loading-widget" }));
export default LoadingWidget;
